import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";
import gql from "graphql-tag";

const query = `
  query Deployments($offset: Int, $limit: Int, $customerId: ID) {
    deployments(offset: $offset, limit: $limit, customerId: $customerId) {
      items {
        id
        codename
        description
      }
      total
    }
  }
`;

export const deploymentsQuery = gql`
  ${query}
`;

const DeploymentSelect = ({ id = "deploymentId", name = "deploymentId", isInsideForm, ...props }) => {
  const handleDataFromResponse = useCallback(data => data.deployments, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => `[${element.codename}] ${element.description}`, []);

  return (
    <EntitiesSelector
      isInsideForm={isInsideForm}
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

DeploymentSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del texto de la opción vacía, si existe (opcional)
   */
  emptyValueText: PropTypes.string,
};

export default DeploymentSelect;
